import AffirmationCard from "@/components/wynn/AffirmationCard";
import BreathingTimer from "@/components/wynn/BreathingTimer";
import MoodCheckin from "@/components/wynn/MoodCheckin";

export default function Studio() {
  return (
    <section
      id="studio"
      data-testid="wynn-studio"
      className="relative border-t border-[#F4F1EC]/10 bg-[#0A0910] scroll-mt-20"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-24 md:pb-28">
        <div className="grid grid-cols-12 gap-8 items-end mb-14">
          <div className="col-span-12 md:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#F4F1EC]/55 font-body">
              A taste of the practice
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.02] text-[clamp(2rem,4.6vw,3.6rem)] font-medium text-[#F4F1EC]">
              Step inside for{" "}
              <span className="italic font-light text-aurora">a moment</span>.
            </h2>
            <p className="mt-5 font-body text-[#F4F1EC]/70 text-lg leading-[1.75] max-w-2xl">
              No sign-up, no app yet. Three small doorways you can open right now —
              the same gentle tools that live inside WYNN. Take what you need and
              return to your work.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <AffirmationCard />
          <BreathingTimer />
          <MoodCheckin />
        </div>
      </div>
    </section>
  );
}
